import * as React from "react";
const SvgFiRrHandScissors = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-scissors_svg__a)">
      <path
        fill="#062147"
        d="M21.657 4.657 18.879 1.88c-1.134-1.134-3.104-1.14-4.25.006l-2.98 3.03-7.975-1.838a3.01 3.01 0 0 0-2.39.461 3.02 3.02 0 0 0-1.261 2.09c-.19 1.478.893 2.97 2.403 3.318l2.3.554-2.292.552c-1.518.352-2.601 1.842-2.411 3.322a3.01 3.01 0 0 0 1.262 2.087 3.01 3.01 0 0 0 2.397.46l5.042-1.208.653 3.267A5.01 5.01 0 0 0 14.28 22H19c2.758 0 5-2.244 5-5v-6.688a7.95 7.95 0 0 0-2.342-5.657zM22 17c0 1.654-1.346 3-3 3h-4.721a3.01 3.01 0 0 1-2.942-2.412l-.857-4.285a1 1 0 0 0-.441-.646 1.1 1.1 0 0 0-.772-.13l-6.043 1.447a.997.997 0 0 1-1.217-.854c-.058-.449.377-1.004.887-1.122l6.34-1.526a.999.999 0 0 0 0-1.944l-6.35-1.527c-.5-.116-.935-.67-.878-1.12a1 1 0 0 1 .422-.7.98.98 0 0 1 .796-.155l12.55 2.892a1 1 0 1 0 .45-1.949l-2.29-.527 2.116-2.149a1.023 1.023 0 0 1 1.414 0l2.778 2.778a5.96 5.96 0 0 1 1.757 4.243v6.687"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-scissors_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandScissors;
